<template>
    <div>
        <div style="color: #00ff96;font-size: 1rem">资产盘点</div>
    <div class="title">盘点单</div>
    <a-descriptions bordered size="small" :column="2">
      <a-descriptions-item label="盘点单号" :span="2">
        {{ detail.inventoryOrder }}
      </a-descriptions-item>
      <a-descriptions-item label="盘点负责人">
        {{ detail.applicant }}
      </a-descriptions-item>
      <a-descriptions-item label="盘点开始时间">
        {{ detail.inventoryTime }}
      </a-descriptions-item>

      <a-descriptions-item label="申请原因" :span="2">
        {{ detail.reason }}
      </a-descriptions-item>
      <a-descriptions-item label="备注" :span="2">
        {{ detail.remark }}
      </a-descriptions-item>
      <a-descriptions-item label="附件" :span="2">
        <a-space v-if="detail.attachmentList">
          <a
            v-for="item in detail.attachmentList"
            :key="item"
            :href="item.completePath"
            >{{ item.name }}</a
          >
        </a-space>
      </a-descriptions-item>
      <a-descriptions-item label="盘点状态" :span="2">
        <DataDictFinder
          dictType="AssetInventoryStatus"
          :dictValue="detail.status"
          iconType="text"
        />
      </a-descriptions-item>
    </a-descriptions>

    <div class="title">物料清单</div>
    <Goods
      type="check"
      :selected="Array.isArray(detail.materialList) ? detail.materialList : []"
    />

    <div class="center">
      <a-space>
          <ButtonField text="关闭" @click="cancel" secondary />
          <ButtonField text="保存" primary @click="pass"/>
      </a-space>
    </div>
  </div>
</template>

<script>
import { check, fetchDetail } from "../api/check";
import Goods from "./components/goods.vue";

export default {
  components: {
    Goods,
  },

  data() {
    return {
      detail: {},
      form: this.$form.createForm(this),
      loading: false,
    };
  },

  mounted() {
    this.getDetail();
  },
  props:{
      id:{
          type:String,
          required:true
      }
  },
  methods: {
    getDetail() {
      fetchDetail({
        id:this.id,
      }).then((res) => {
        if (res) {
          this.detail = res;
        }
      });
    },
    pass() {
      this.loading = true;
      check({
        ...this.detail,
      })
        .then(() => {
          this.getDetail();
          this.cancel();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    cancel() {
        this.$emit('show-check-index');
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  font-weight: bold;
  margin: 1rem 0;
  color: #adadad;
  border-left: 1px solid #adadad;
  padding-left: 1rem;
}
.center {
  margin-top: 24px;
  margin-bottom: 24px;
}
::v-deep .ant-descriptions-bordered .ant-descriptions-item-label{
  background-color:rgb(14, 27, 52);
  color: #fff;
}
::v-deep .ant-descriptions-bordered .ant-descriptions-item-label,::v-deep  .ant-descriptions-bordered .ant-descriptions-item-content{
  border-right: 0.1px solid #67927f;
  color: #d9d9d9;
}

::v-deep .ant-descriptions-bordered .ant-descriptions-row{
  border: 0.1px solid #67927f;
  color: #d9d9d9;
}

::v-deep .ant-descriptions-bordered .ant-descriptions-view{
  border: 0.1px solid #67927f;
  color: #d9d9d9;
}
</style>
